export default __webpack_public_path__ + "static/media/img_area_40.ff66983b.svg";